import { HttpClient } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { ReplaySubject, Subject } from 'rxjs';
import { AppConfigProvider } from '../app-config/app-config';



/*
  Generated class for the KioskServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class KioskServiceProvider{
  private kioskMonitorInterval;
  private appId;
  public appActivity = new Subject();
  public startSliders = new Subject();

  get isKiosk() {
    return window.location.href.indexOf('kiosk=1') > -1;
  }

  constructor(public http: HttpClient) {
    console.log('Dev mode?', isDevMode());
  }

  initialize(appId) {
    this.appId = appId;
    if (!isDevMode()) {
      this.pingKioskMonitor();
    }
  }

  private pingKioskMonitor() {
    clearInterval(this.kioskMonitorInterval);
    this.kioskMonitorInterval = setInterval(() => {
      this.http.get(`https://phc-dev.eventerac.com/wp-json/phc/v2/apps/${this.appId}/kiosk-monitor/update`).subscribe(() => {
        console.log('Pinged Kiosk Monitor');
      });
    }, 15000);
  }



}



// WEBPACK FOOTER //
// ./src/providers/kiosk-service/kiosk-service.ts